/* eslint-disable @typescript-eslint/semi */
/* eslint-disable @typescript-eslint/comma-dangle */
const routeNames = {
    signin: '/',
    signinConfirm: '/signin-confirm',
    signup: '/register',
    forgotPassword: '/forgot-password',
    forgotPasswordReset: '/forgot-password-reset',
    confirmationScreen: '/confirmation',
    acceptChoirInvitation: '/accept-choir-invitation',
    waitlist: '/epoch-waitlist',
    privacyPolicy: '/privacy',
    deleteAccount: '/discard-account',
    contactUs: '/contact-us',
    claimChoir: '/claim-choir/:uuid',
    home: '/home',
    community: '/community',
    marketplace: '/marketplace',
    rehearsal: '/rehearsals',
    exercises: '/exercises',
    choir: '/choirs',
    projects: '/projects',
    teaching: '/teaching',
    profile: '/profile',
    contributions: '/contributions',
    setlists: '/setlists',
    share: '/pub-share',
    uploads: '/uploads',
    requestSongs: '/request-songs',
    accountInformation: '/account-information',
    changePassword: '/change-password',
    roleRequest: '/request-role',
    notifications: '/notifications',
    transactionHistory: '/transaction-history',
    noWhere: '*',
};

export default routeNames;
